// extracted by mini-css-extract-plugin
module.exports = {"calc":"CalculatingIndicator_calc__hEfFX","spin":"CalculatingIndicator_spin__W6asU"};